export default __webpack_public_path__ + "static/media/i-have-a-code-iphone.392966e4.png";